import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import {
  ISubscriptionPlan,
  ISubscriptionPlanDeleteVerificationData,
  TSubscriptionPlanStatuses,
} from '.';

export type TAdminCreateSubscriptionPlan = {
  name: ISubscriptionPlan['name'];
  status: ISubscriptionPlan['status'];
  billingPeriod: ISubscriptionPlan['billingPeriod'];
  features: ISubscriptionPlan['features'];
  courseChecked: boolean;
  creditsChecked: boolean;
  isMostPopular: boolean;
  criteria?: ISubscriptionPlan['criteria'];
  courses?: string[];
  credits?: number;
};

export type TAdminGetSubscriptionPlans = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
  statuses?: TSubscriptionPlanStatuses[];
};

export type TAdminUpdateSubscriptionPlan = {
  id: string;
  name: ISubscriptionPlan['name'];
  status: ISubscriptionPlan['status'];
  billingPeriod: ISubscriptionPlan['billingPeriod'];
  features: ISubscriptionPlan['features'];
  courseChecked: boolean;
  creditsChecked: boolean;
  isMostPopular: boolean;
  criteria?: ISubscriptionPlan['criteria'];
  courses?: string[];
  credits?: number;
};

const apiDataProvider = new APIDataProvider();

const adminGetSubscriptionPlansModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
  statuses,
}: TAdminGetSubscriptionPlans) => {
  let path = `${AdminApiPaths.adminSubscriptionPlans}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  if (statuses) {
    path += `&statuses=${statuses}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<ISubscriptionPlan>>
  >(path);

  return response.data;
};

export const adminCreateSubscriptionPlan = createAsyncThunk(
  '/admin/subscription-plans/create',
  async (data: TAdminCreateSubscriptionPlan) => {
    const path = `${AdminApiPaths.adminSubscriptionPlans}`;

    const response = await apiDataProvider.post<
      TApiResponse<ISubscriptionPlan>
    >(path, data);

    return response.data;
  }
);

export const adminUpdateSubscriptionPlan = createAsyncThunk(
  '/admin/subscription-plans/update',
  async (data: TAdminUpdateSubscriptionPlan) => {
    const path = `${AdminApiPaths.adminSubscriptionPlans}/${data.id}`;

    const response = await apiDataProvider.put<TApiResponse<ISubscriptionPlan>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminDeleteSubscriptionPlan = createAsyncThunk(
  '/admin/subscription-plans/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminSubscriptionPlans}/${id}`;

    const response = await apiDataProvider.delete<
      TApiResponse<ISubscriptionPlan>
    >(path);

    return response.data;
  }
);

export const adminVerifySubscriptionPlanDelete = createAsyncThunk(
  '/admin/subscription-plans/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminSubscriptionPlans}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<ISubscriptionPlanDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetSubscriptionPlans = createAsyncThunk(
  '/admin/subscription-plans/list',
  adminGetSubscriptionPlansModule
);

export const adminGetSubscriptionPlansForDropDown = createAsyncThunk(
  '/admin/subscription-plans/dropdown-list',
  adminGetSubscriptionPlansModule
);
